import { render, staticRenderFns } from "./IconHearth.vue?vue&type=template&id=65ff8f64&"
import script from "./IconHearth.vue?vue&type=script&lang=js&"
export * from "./IconHearth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports